import React, { useState, useEffect } from "react";
import "./ContactForm.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
function ContactForm({
  type = "contact-form",
  title = "Have a Question? Let's Talk.",
  showInfo = true
}) {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    challenges: ""
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [widgetId, setWidgetId] = useState(null);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    console.log('RECAPTCHA_SITE_KEY from window:', window.RECAPTCHA_SITE_KEY);
    const renderRecaptcha = () => {
      const container = document.getElementById("recaptcha-contact-form");
      if (!container || container.innerHTML !== "" || !window.RECAPTCHA_SITE_KEY) return;

      if (!window.grecaptcha || typeof window.grecaptcha.render !== 'function') return;

      try {
        const id = window.grecaptcha.render(container, {
          sitekey: window.RECAPTCHA_SITE_KEY,
        });
        setWidgetId(id);
      } catch (err) {
        console.error("reCAPTCHA ContactForm render error:", err);
      }
    };

    if (window.grecaptcha && window.RECAPTCHA_SITE_KEY) {
      renderRecaptcha();
      return;
    }

    const interval = window.setInterval(() => {
      if (window.grecaptcha && window.RECAPTCHA_SITE_KEY) {
        window.clearInterval(interval);
        renderRecaptcha();
      }
    }, 250);

    return () => window.clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.full_name || !formData.email) {
      setMessage("❌ Name and Email are required.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const token = getResponse(widgetId);
      if (!token) {
        setMessage("❌ Please complete the reCAPTCHA");
        setLoading(false);
        return;
      }

      const fd = new FormData();
      fd.append("full_name", formData.full_name);
      fd.append("email", formData.email);
      fd.append("phone", formData.phone);
      fd.append("challenges", formData.challenges);
      fd.append("_type", type);
      fd.append("tk", token);

      const response = await fetch(
        BASE_URL + "/DemoApi/saveData",
        {
          method: "POST",
          body: fd
        }
      );

      const result = await response.json();
      if (result.status) {
        setMessage("✅ Message sent successfully!");
        setFormData({ full_name: "", email: "", phone: "", challenges: "" });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }
    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }
    setLoading(false);
  };

  return (
    <section className="contact-section-premium">
      <div className="contact-container-premium">
        <div className="contact-grid-premium">
          {showInfo && (
            <div className="contact-info-premium">
              <span className="info-badge-premium">Get in Touch</span>
              <h2 className="info-title-premium">{title}</h2>
              <p className="info-subtitle-premium">Our team of experts is ready to help you accelerate your digital banking journey.</p>

              <div className="info-cards-premium">
                <div className="info-card-premium">
                  <div className="info-icon-premium"><FaPhoneAlt /></div>
                  <div className="info-details-premium">
                    <h4>Call Us</h4>
                    <p>+91 9447 094 230</p>
                    <p>+91 6282 900 770</p>
                  </div>
                </div>

                <div className="info-card-premium">
                  <div className="info-icon-premium"><FaEnvelope /></div>
                  <div className="info-details-premium">
                    <h4>Email Us</h4>
                    <p>info@ignosi.in</p>
                  </div>
                </div>

                <div className="info-card-premium">
                  <div className="info-icon-premium"><FaMapMarkerAlt /></div>
                  <div className="info-details-premium">
                    <h4>Visit Us</h4>
                    <p>ACE-13, 4th Floor, CDAC, Technopark, Trivandrum - 695581</p>
                  </div>
                </div>
              </div>

              <div className="contact-map-premium">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d63126.5342243995!2d76.881962!3d8.55667!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05bff50237daad%3A0x52446b2a8639265f!2sIGNOSI%20ENTERPRISES%20-%20ALL%20IN%20ONE%20SAAS%20MODEL%20INDUSTRY%20SPECIFIC%20BANKING%20SOFTWARE!5e0!3m2!1sen!2sus!4v1771657535341!5m2!1sen!2sus" loading="lazy" title="Ignosi Location"></iframe>
              </div>
            </div>
          )}

          <div className="contact-form-premium">
            <div className="form-glass-premium">
              <h3>Send a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="input-group-premium">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="full_name"
                    placeholder="Enter your name"
                    value={formData.full_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-row-premium">
                  <div className="input-group-premium">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="name@company.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group-premium">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      name="phone"
                      placeholder="+91"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="input-group-premium">
                  <label>Message(Optional)</label>
                  <textarea
                    name="challenges"
                    placeholder="Tell us about your requirements..."
                    rows="4"
                    value={formData.challenges}
                    onChange={handleChange}
                  />
                </div>

                <div
                  id="recaptcha-contact-form"
                  style={{ marginBottom: "15px" }}
                ></div>

                <button type="submit" className="submit-btn-premium" disabled={loading}>
                  {loading ? "Sending..." : "Submit Enquiry →"}
                </button>

                {message && (
                  <p className={`form-status-premium ${message.includes("✅") ? "success" : "error"}`}>
                    {message}
                  </p>
                )}
              </form>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
}

export default ContactForm;